export default {"src":"/_next/static/media/governance_framework_accountability_structures.62ec1fd6.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};